import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

/** Sign-in itself answers 401 for a wrong password; that is not a dead token. */
const isSignInCall = (url: string) =>
  url.includes('/auth/login') ||
  url.includes('/auth/forgot-password') ||
  url.includes('/auth/reset-password');

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  // Only handle admin token - customer auth is handled in CustomerAuthService
  // Exclude customer-related endpoints from this interceptor
  const isCustomerEndpoint = req.url.includes('/api/customers/') ||
                             req.url.includes('/api/orders/') ||
                             req.url.includes('/payments/dna/');

  if (!isCustomerEndpoint) {
    const token = localStorage.getItem('foodciti_token');

    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // A panel token the API no longer accepts — expired, the login was
      // deactivated, or it is a till/driver account, which the panel no longer
      // admits. Without this the user sits on a page where every call fails.
      const stale =
        error.status === 401 &&
        !isCustomerEndpoint &&
        !isSignInCall(req.url) &&
        !!localStorage.getItem('foodciti_token');

      if (stale) {
        localStorage.removeItem('foodciti_token');
        localStorage.removeItem('foodciti_user');
        localStorage.removeItem('restaurantId');
        void router.navigate(['/login']);
      }

      return throwError(() => error);
    })
  );
};
